import "./App.css";
import Header from "./components/Header/Header";
import Peoples from "./components/Peoples/Peoples";

function App() {
  return (
    <div className="App">
      <Header></Header>
      <Peoples></Peoples>
    </div>
  );
}

export default App;
